import {useLocalStorage} from '../../common/hooks/useLocalStorage';
import {UseStorageResult} from '../../common/hooks/useStorage';
import {InstallOutcome} from '../types';

const InstallOutcomeKey = 'appInstallOutcome';

export type UseStoredAppInstallOutcome = UseStorageResult<InstallOutcome>;

export function useStoredAppInstallOutcome(): UseStoredAppInstallOutcome {
  return useLocalStorage<InstallOutcome>(InstallOutcomeKey);
}
